import { Navigate } from "react-router-dom";
import { getCookie } from "./function";

function PublicRoute(props) {
  const auth = getCookie("token");
  if (!auth) {
    return props.children;
  } else {
    return <Navigate to="/structure-monitor" />;
  }
}
export default PublicRoute;
